export default __webpack_public_path__ + "static/media/handheld.8fbb1aa1.png";